import { PropertyDetail } from '../types'
import { ClientPropertiesActions, clientPropertiesTypes } from './types'

const actions = {
  fetchClientProperties: (
    customerId: string,
    callback?: (succ: boolean) => void
  ): ClientPropertiesActions => ({
    type: clientPropertiesTypes.FETCH_CLIENT_PROPERTIES,
    customerId,
    callback
  }),

  setClientProperties: (payload: PropertyDetail[] | null): ClientPropertiesActions => ({
    type: clientPropertiesTypes.SET_CLIENT_PROPERTIES,
    payload
  })
}

export default actions

